// extracted by mini-css-extract-plugin
export default {"lockedNotice":"edit-corporate-name-modal_lockedNotice__vfaUB"};